import DpcPicture from '@components/atoms/picture/dpc-picture.vue';
import DpcFloatingLayer from '@components/atoms/floating-layer/dpc-floating-layer.vue';
import DpcHeader from '@components/organisms/header/dpc-header.vue';

export default [DpcPicture, DpcHeader, DpcFloatingLayer];
